import React from 'react';
import classNames from 'classnames';

import { useScrollRestoration } from '../../hooks/useScrollRestoration';

import './MainContent.scss';

export type MainContentProps = {
  width?: 'fit' | 'full';
  scrollRestorationPrefix?: string;
  children: React.ReactNode;
};

export const MainContent: React.FC<MainContentProps> = ({
  width,
  scrollRestorationPrefix,
  children,
}) => {
  const ref = useScrollRestoration(scrollRestorationPrefix);

  return (
    <div className='dmx-mainContent' ref={ref}>
      <div
        className={classNames({
          'dmx-mainContent--inner': true,
          'dmx-mainContent--inner-min': width === undefined,
          'dmx-mainContent--inner-fit': width === 'fit',
          'dmx-mainContent--inner-full': width === 'full',
        })}
      >
        {children}
      </div>
    </div>
  );
};
